import './App.css';
import HandMatrix from './components/HandMatrix';

function App() {
  return (
    <div className="App">
      <HandMatrix />
    </div>
  );
}

export default App;
